import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (min-width: 425px) {
        height: 350px;
    }
`;

export const Slides = styled.div`
    width: 100%;

    .indicator {
        cursor: pointer;
        height: 22px;
        width: 22px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px #666 solid;
        margin: 2px;
        font-size: 12px;
        font-weight: bold;
      }
      
      .indicator: hover{
        background: #999;
      }

      .indicator.active {
        color: #fff;
        background: #666;
      }

    .images-wrap{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .react-slideshow-container{
        @media (min-width: 425px) {
            max-height: 300px;
        } 
    }
        
`;

export const EachSlideEffect = styled.div`
    width: 100%;
`;

export const BackgroundImage = styled.img`
    width: 100%;
    height: 300px;
    object-fit: contain;
`;